import { render, staticRenderFns } from "./HeaderToggleRouteSwitch.vue?vue&type=template&id=76791372&"
import script from "./HeaderToggleRouteSwitch.vue?vue&type=script&lang=js&"
export * from "./HeaderToggleRouteSwitch.vue?vue&type=script&lang=js&"
import style0 from "./HeaderToggleRouteSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports